import { HERO } from './content/hero';
import { FEATURES } from './content/features';
import { PRICING } from './content/pricing';
import { QA, DEMO, DISCOUNT, POPUP, SEO } from './content/misc';

export const DOWNLOAD_LINKS = {
    appleSilicon: 'https://convocue-testupdater.s3.us-east-2.amazonaws.com/Convocue+Interview+Copilot-5.3.3-arm64.dmg',
};

const buildVariant = (variant) => ({
    hero: HERO[variant],
    features: FEATURES[variant],
    pricing: PRICING[variant],
    qa: QA[variant],
    demo: DEMO[variant],
    discount: DISCOUNT[variant],
    popup: POPUP[variant],
    seo: SEO[variant],
});

export const CONTENT = {
    default: buildVariant('default'),
    assistant: buildVariant('assistant'),
};

// Section-level exports for components that only need one slice of content.
export { HERO, FEATURES, PRICING, QA, DEMO, DISCOUNT, POPUP, SEO };
